import {
  Col,
  Form,
  Row,
  Input,
  InputNumber,
} from "antd";

const { TextArea } = Input;

const CustomerDetails = ({ customerData }) => {
  return (
    <>
      <Row gutter={16}>
        <Col xs={24} sm={8}>
          <Form.Item
            name="name"
            label="Customer Name"
            rules={[{ required: true, message: "Enter customer name" }]}
          >
            <Input size="large" />
          </Form.Item>
        </Col>

        <Col xs={24} sm={8}>
          <Form.Item
            name="mobile_no"
            label="Mobile No"
            rules={[{ required: true, message: "Enter mobile number" }]}
          >
            <InputNumber size="large" style={{ width: "100%" }} />
          </Form.Item>
        </Col>

        <Col xs={24} sm={8}>
          <Form.Item name="address" label="Address">
            <TextArea rows={2} size="large" />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col xs={24} sm={8}>
          <Form.Item name="note" label="Note / Comment">
            <TextArea rows={2} size="large" />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};

export default CustomerDetails;